import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store/hooks";
import {
  getColumnVisibilityModel,
  storeColumnVisibilityModel,
} from "../../../../../lib/functions";
import { createColumns } from "./columns";
import { ITableProps } from "./interfaces";

function Table({ rows, onEdit }: ITableProps) {
  const { t } = useTranslation();
  const [pageSize, setPageSize] = useState<number>(25);
  const columns = useMemo(() => createColumns({ t, onEdit }), [t, onEdit]);
  const columnVisibilityModel = useMemo(
    () => getColumnVisibilityModel("ProspectColumnVisibilityModel") ?? {},
    []
  );
   const user = useAppSelector((state) => state.auth.user);
    const displayedRows = useMemo(() => {
    if (!rows) return [];
    const canViewOnlyWeb= user?.user_group?.group_permissions?.canViewOnlyWeb;
    if (canViewOnlyWeb === 1) {
  
      return rows.filter((r) => (r.ext?.pubblicatoSuWeb === true));
    }
    return rows;
  }, [rows, user?.user_group?.group_permissions?.canViewOnlyWeb]);
  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      {!!columnVisibilityModel && (
        <DataGrid
          rows={displayedRows}
          columns={columns}
          columnVisibilityModel={columnVisibilityModel || undefined}
          onColumnVisibilityModelChange={(newModel) =>
            storeColumnVisibilityModel(
              "ProspectColumnVisibilityModel",
              newModel
            )
          }
          rowsPerPageOptions={[25, 50, 100]}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          pageSize={pageSize}
          disableSelectionOnClick
        />
      )}
    </Box>
  );
}

export default Table;
